import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=cca4f7be&scoped=true&"
import script from "./DraggableWrapper.vue?vue&type=script&lang=js&"
export * from "./DraggableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DraggableWrapper.vue?vue&type=style&index=0&id=cca4f7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca4f7be",
  null
  
)

export default component.exports